import React from "react";

function formatWithCommas(raw) {
  if (raw === "" || raw == null) return "";
  const str = String(raw);
  const [int, dec] = str.split(".");
  const formatted = int.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return dec !== undefined ? `${formatted}.${dec}` : formatted;
}

const INPUT_CLASS =
  "w-full rounded-xl border border-palette-gray-divider px-4 py-3 outline-none text-palette-gray-primary focus:ring-2 focus:ring-palette-indigo-label";

export default function NumberField({
  label,
  value,
  onChange,
  placeholder,
  min,
  max,
  step,
  disabled = false,
  className = "",
  money = false,
}) {
  const disabledClass = disabled ? "bg-palette-gray-subtle cursor-not-allowed opacity-60" : "";

  if (money) {
    const handleChange = (e) => {
      const raw = e.target.value.replace(/[^\d.]/g, "");
      const parts = raw.split(".");
      let clean;
      if (parts.length > 2) {
        clean = `${parts[0]}.${parts[1]}`;
      } else if (parts.length === 2) {
        clean = `${parts[0]}.${parts[1].slice(0, 2)}`;
      } else {
        clean = parts[0];
      }
      onChange?.(clean);
    };

    return (
      <div className={className}>
        {label && <label className="block text-sm font-medium">{label}</label>}
        <div className="mt-2">
          <input
            type="text"
            inputMode="decimal"
            disabled={disabled}
            value={formatWithCommas(value)}
            onChange={handleChange}
            placeholder={placeholder}
            className={`${INPUT_CLASS} ${disabledClass}`}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={className}>
      {label && <label className="block text-sm font-medium">{label}</label>}
      <div className="mt-2">
        <input
          type="number"
          inputMode="decimal"
          min={min}
          max={max}
          step={step}
          disabled={disabled}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder={placeholder}
          className={`${INPUT_CLASS} ${disabledClass}`}
        />
      </div>
    </div>
  );
}
